import React from 'react';
import './index.scss';

export type ButtonProps = {
    text: string;
    infoText: string;
    ariaLabel: string;
    onClick: () => void;
};

type SGPBadgeProps = {
    className?: string;
    fillBackground: string;
    fill: string;
};

const SGPBadgeDark: SGPBadgeProps = {
    fillBackground: '#12320B',
    fill: '#53D337'
};

export const SGPBadge: React.FC<SGPBadgeProps> = React.memo(function SGPBadge(sgpBadgeTheme: SGPBadgeProps) {
    return (
        <svg
            data-testid="sgp-badge"
            className={sgpBadgeTheme.className}
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0.5" y="0.5" width="22" height="15" rx="1.5" fill={sgpBadgeTheme.fillBackground} />
            <path
                d="M6.68363 11.58C6.40363 11.58 6.09697 11.5633 5.76363 11.53C5.43697 11.5033 5.14697 11.4633 4.89363 11.41V10.29C5.57363 10.3433 6.04363 10.37 6.30363 10.37C6.53697 10.37 6.71363 10.3567 6.83363 10.33C6.95363 10.3033 7.04363 10.2567 7.10363 10.19C7.15697 10.1367 7.1903 10.0633 7.20363 9.97C7.22363 9.87 7.23363 9.73 7.23363 9.55C7.23363 9.30333 7.2203 9.13 7.19363 9.03C7.16697 8.92333 7.1103 8.84667 7.02363 8.8C6.94363 8.74667 6.8003 8.7 6.59363 8.66L5.65363 8.49C5.3203 8.43 5.0903 8.24667 4.96363 7.94C4.83697 7.63333 4.77363 7.19 4.77363 6.61C4.77363 6.04333 4.85363 5.61 5.01363 5.31C5.1803 5.01 5.40697 4.80667 5.69363 4.7C5.9803 4.59333 6.34363 4.54 6.78363 4.54C7.0903 4.54 7.38363 4.56 7.66363 4.6C7.9503 4.64 8.18363 4.68 8.36363 4.72V5.84C8.00363 5.78 7.6003 5.75 7.15363 5.75C6.91363 5.75 6.72697 5.76 6.59363 5.78C6.46697 5.8 6.37363 5.83667 6.31363 5.89C6.2403 5.94333 6.19363 6.02 6.17363 6.12C6.15363 6.22 6.14363 6.36667 6.14363 6.56C6.14363 6.76667 6.15363 6.91667 6.17363 7.01C6.2003 7.10333 6.24363 7.17 6.30363 7.21C6.36363 7.25 6.46697 7.28333 6.61363 7.31L7.49363 7.47C7.72697 7.50333 7.92363 7.57667 8.08363 7.69C8.2503 7.79667 8.3803 7.97667 8.47363 8.23C8.56697 8.49667 8.61363 8.87333 8.61363 9.36C8.61363 9.99333 8.53697 10.47 8.38363 10.79C8.2303 11.11 8.01697 11.3233 7.74363 11.43C7.47697 11.53 7.12363 11.58 6.68363 11.58ZM11.4172 8.68V7.5H13.3072V11.37C13.0739 11.43 12.7906 11.48 12.4572 11.52C12.1239 11.56 11.8139 11.58 11.5272 11.58C10.8939 11.58 10.4206 11.4867 10.1072 11.3C9.80056 11.1067 9.58723 10.7667 9.46723 10.28C9.35389 9.78667 9.29723 9.04667 9.29723 8.06C9.29723 7.08 9.35723 6.34667 9.47723 5.86C9.60389 5.36667 9.83056 5.02333 10.1572 4.83C10.4839 4.63667 10.9739 4.54 11.6272 4.54C11.8939 4.54 12.1839 4.56 12.4972 4.6C12.8106 4.64 13.0772 4.68667 13.2972 4.74V5.87C12.7239 5.79 12.3072 5.75 12.0472 5.75C11.5939 5.75 11.2806 5.78667 11.1072 5.86C10.9406 5.93333 10.8239 6.12333 10.7572 6.43C10.6972 6.73 10.6672 7.27333 10.6672 8.06C10.6672 8.79333 10.6872 9.31667 10.7272 9.63C10.7672 9.93667 10.8439 10.1433 10.9572 10.25C11.0772 10.3567 11.2772 10.41 11.5572 10.41C11.6172 10.41 11.7772 10.4 12.0372 10.38V8.68H11.4172ZM14.3003 4.62H16.5703C17.0569 4.62 17.4236 4.70667 17.6703 4.88C17.9236 5.05333 18.0936 5.30667 18.1803 5.64C18.2669 5.96667 18.3103 6.40333 18.3103 6.95C18.3103 7.47667 18.2703 7.90667 18.1903 8.24C18.1103 8.56667 17.9436 8.82667 17.6903 9.02C17.4369 9.20667 17.0603 9.3 16.5603 9.3H15.6803V11.5H14.3003V4.62ZM16.2203 8.09C16.4469 8.09 16.6069 8.06333 16.7003 8.01C16.7936 7.95667 16.8536 7.85667 16.8803 7.71C16.9136 7.55667 16.9303 7.30333 16.9303 6.95C16.9303 6.59667 16.9136 6.34667 16.8803 6.2C16.8536 6.05333 16.7936 5.95667 16.7003 5.91C16.6136 5.85667 16.4569 5.83 16.2303 5.83H15.6803V8.09H16.2203Z"
                fill={sgpBadgeTheme.fill}
            />
            <rect x="0.5" y="0.5" width="22" height="15" rx="1.5" stroke={sgpBadgeTheme.fill} />
        </svg>
    );
});

export const SGPBadgeWithDefaultProps = () => <SGPBadge {...SGPBadgeDark} />;

export const SGPTurnOnButton: React.FC<ButtonProps> = React.memo(function SGPTurnOnButton(props: ButtonProps) {
    return (
        <button
            type="button"
            className="event-page-widget-sgp-button event-page-widget-sgp-button--turn-on"
            onClick={props.onClick}
            aria-label={props.ariaLabel}
            data-testid="event-page-widget-sgp-button-turn-on"
        >
            <div className="event-page-widget-sgp-button__titles event-page-widget-sgp-button__titles--turn-on">
                <span className="event-page-widget-sgp-turn-on-button__info-title">{props.infoText}</span>
                <span className="event-page-widget-sgp-turn-on-button__title">{props.text}</span>
            </div>
            <div className="event-page-widget-sgp-turn-on-button__icons">
                <SGPBadge className="event-page-widget-sgp-turn-on-button__badge" {...SGPBadgeDark} />
                <svg
                    className="event-page-widget-sgp-turn-on-button__right-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path d="M9 5.9126L15 11.9126L9 17.9126" stroke="#ABABAB" strokeWidth="2" />
                </svg>
            </div>
        </button>
    );
});
